import React from 'react'
import TokensReceived from './single'
import { TokensReceivedProps } from './interface'

export const MIN_NUMBER_OF_COINS_TO_DISPLAY = 1
export const DEFAULT_MAX_COINS_TO_DISPLAY = 9

const TokensReceivedSection: React.FC<TokensReceivedProps> = ({ indexInfo }) => {
  return <TokensReceived indexInfo={indexInfo} />
}

export default TokensReceivedSection
